import { useMutation, useQueryClient } from '@tanstack/react-query'
import { uploadCompanyFiles } from 'api/company/uploadCompanyFiles'
import { companyFilesKey } from './keys'

export function useUploadCompanyFilesMutation(companyId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (files: File[]) => uploadCompanyFiles(companyId, files),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: companyFilesKey(companyId),
      })
    },
  })
}
